import { Component } from "react";

/**
 * Catches webpack ChunkLoadError (stale chunk hashes after a new deployment)
 * and reloads the page once to fetch the latest bundle.
 * Works transparently — users never see a broken screen.
 */
class ChunkErrorBoundary extends Component {
    componentDidCatch(error) {
        const isChunkError =
            error?.name === "ChunkLoadError" ||
            /Loading chunk [\d]+ failed/i.test(error?.message) ||
            /Loading CSS chunk [\d]+ failed/i.test(error?.message);

        if (isChunkError) {
            window.location.reload();
        }
    }

    render() {
        return this.props.children;
    }
}

export default ChunkErrorBoundary;
